import { Injectable } from '@angular/core';
import { AppConstants } from '../app_setting/app-constants';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ArticleService extends BaseService {

  baseUrl = environment.apiBaseUrl;

  getListArticles(param: any, onSuccess: (data) => void, onError: (data) => void = null): any{
    if(!param){
      this.get(`article&numberCharShortDesc=${100}`).subscribe(
        resp => {
          if (resp.alert.code === 200) {
              onSuccess(resp.data);
            } else {
              onError(resp.alert);
            }
        },
        err => {
          if (onError) {
              onError(err);
          }
        }
      );
    } else if (param) {
      param = `${param}&numberCharShortDesc=${75}`
      this.get(`article?${param}`).subscribe(
        resp => {
          if (resp.alert.code === 200) {
              onSuccess(resp.data);
            } else {
              onError(resp.alert);
            }
        },
        err => {
          if (onError) {
              onError(err);
          }
        }
      );
    }
  }

  getArticleDetail(id: string, onSuccess: (data) => void, onError: (data) => void = null): any{
    this.get(`article/${id}?numberCharShortDesc=100`).subscribe(
      resp => {
        if (resp.alert.code === 200) {
            onSuccess(resp.data);
          } else {
            onError(resp.alert);
          }
      },
      err => {
        if (onError) {
            onError(err);
        }
      }
    );
  }

  getArticlesImage(imageUrl: any): any{
    if (imageUrl === null || imageUrl === '' || imageUrl === undefined){
      return AppConstants.NoImageDefault;
    }

    return imageUrl;
  }

  getArticleTag(): Observable<any>{
    return this.get(`article/list-filter-tags`);
  }

}
